import React, { Component } from "react";
import Login from "../login/Login";
import Forgot from "../password/Forgot";
import {
  Route,
  Switch,
  withRouter,
  useParams,
  useLocation,
} from "react-router-dom";
import SignUp from "../signup/Signup";

import TeamMemberOnboardingForm from "../home/TeamMemberOnboarding/TeamMemberOnboarding";
import Onboarding from "../home/onboarding/Onboarding";
import ServiceSettings from "../home/onboarding/ServiceSettings";
import BookingSettings from "../home/onboarding/BookingSettings";
import InviteTeamMember from "../home/onboarding/Invite";
import InviteMember from "../team-members/InviteTeamMember";
import Layout from "../layout/Layout";
import Dashboard from "../dashboard/Dashboard";
import Bookings from "../bookings/Bookings";
import BookingDetails from "../bookings/Booking-details";
import Payments from "../payments/Payments";
import TeamMembers from "../team-members/TeamMembers";
import ManageMember from "../team-members/ManageMember";

import Settings from "../settings/Settings";
import ManageServices from "../settings/ServicesSettings";
import ManageDiscount from "../settings/DiscountSettings";
import ManageBusiness from "../settings/BusinessSettings";
import OpeningHours from "../settings/OpeningHours";
import OpeningHoursOnboarding from "../settings/OpeningHoursOnboarding";
import ProfileSettings from "../settings/ProfileSettings";
import PasswordSettings from "../settings/PasswordSettings";
import PayoutSettings from "../settings/PayoutSettings";
import ManageBookings from "../settings/BookingSettings";
import { connect } from "react-redux";
import StatsProvider from "../contexts/StatsContext";
import IntegrationSettings from "../settings/IntegrationSettings";
import ManageCategories from "../settings/ManageCategories";
import PolicySettings from "../settings/PolicySettings";

const mapStateToProps = (state) => ({
  loginData: state.rizevo_login_data,
  business: state.business,
  userProfile: state.userProfile,
});

export default withRouter(
  connect(mapStateToProps)(
    class routes extends Component {
      componentDidMount() {
        this.unlisten = this.props.history.listen((location) => {
          window.scrollTo(0, 0);
        });
      }
      componentWillUnmount() {
        this.unlisten();
      }

      render() {
        return (
          <div>
            <StatsProvider>
              <Switch>
                <Route exact path="/login" component={Login} />
                <Route exact path="/signup" component={SignUp} />
                <Route exact path="/forgot-password" component={Forgot} />

                <Layout>
                  {/* Routes for business owners */}
                  <Switch>
                    <Route exact path="/" component={Dashboard} />
                    <Route
                      exact
                      path="/onboarding"
                      component={() => {
                        return (
                          <>
                            {this.props.userProfile?.account_type !==
                              "business_team_member" ? (
                              <Onboarding location={this.props.location} />
                            ) : (
                              <TeamMemberOnboardingForm
                                location={this.props.location}
                              />
                            )}
                          </>
                        );
                      }}
                    />
                    <Route
                      exact
                      path="/onboarding/service/settings/:business_invite_code"
                      component={ServiceSettings}
                    />
                    <Route
                      exact
                      path="/onboarding/booking/settings/:business_invite_code"
                      component={BookingSettings}
                    />
                    <Route
                      exact
                      path="/onboarding/team/invite/:business_invite_code"
                      component={InviteTeamMember}
                    />
                    <Route path="/payments" component={Payments} />

                    {/* booking route */}
                    <Route
                      exact
                      path="/bookings/settings"
                      component={ManageBookings}
                    />

                    <Route
                      exact={window.innerWidth < 600}
                      path="/bookings"
                      component={Bookings}
                    />

                    <Route
                      exact
                      path="/bookings/:id/booking"
                      component={Booking_details}
                    />
                    {/* end of booking routes */}

                    {/* team routes */}
                    <Route
                      exact={window.innerWidth < 600}
                      path="/team"
                      component={TeamMembers}
                    />

                    <Route
                      exact
                      path="/team/:member_uuid/member/"
                      component={ManageMember}
                    />
                    <Route exact path="/invite" component={InviteMember} />
                    {/* end of team routes */}

                    <Route exact path="/settings" component={Settings} />
                    <Route
                      exact
                      path="/services/settings"
                      component={ManageServices}
                    />
                      <Route
                      exact
                      path="/services/settings/:action"
                      component={ManageServices}
                    />

                    <Route
                      exact
                      path="/discount/settings"
                      component={ManageDiscount}
                    />
    <Route
                      exact
                      path="/policy/settings"
                      component={PolicySettings}
                    />


                    <Route
                      exact
                      path="/business/settings"
                      component={ManageBusiness}
                    />

                    <Route
                      exact
                      path="/business/opening_hours"
                      component={OpeningHours}
                    />

                    <Route
                      exact
                      path="/onboarding/opening_hours"
                      component={OpeningHoursOnboarding}
                    />

                    {/* profile settings route */}
                    <Route
                      exact={window.innerWidth < 600}
                      path="/profile/settings"
                      component={ProfileSettings}
                    />

                    <Route
                      exact
                      path="/profile/settings/password"
                      component={PasswordSettings}
                    />
                    {/* end of profile settings route */}

                    <Route
                      exact
                      path="/payout/settings"
                      component={PayoutSettings}
                    />
                    <Route
                      exact
                      path="/profile/integration"
                      component={IntegrationSettings}
                    />
                    <Route exact
                      path="/categories/settings/:action"
                      component={ManageCategories}
                    />

                    <Route exact
                      path="/categories/settings"
                      component={ManageCategories}
                    />


                  </Switch>
                  {/* if user has no business redirect to onboarding page */}
                  {/* {this.props.business === false ? (
                    <>
                      <Redirect
                        to={{
                          pathname: `/onboarding`,
                          search: this.props.location?.search,
                        }}
                      ></Redirect>
                    </>
                  ) : (
                    ""
                  )} */}

                  {/* routes for team members */}
                </Layout>
              </Switch>
            </StatsProvider>
          </div>
        );
      }
    }
  )
);

function Booking_details() {
  let { id } = useParams();
  let location = useLocation();
  return <BookingDetails id={id} location={location} />;
}
